import { formatNumberLocale } from "../../../_utils"

export function getColumns() {
  const columns = [
      {
        name: 'Ref',
        key:'ref',
        selector: (row:any) => row.ref,
        sortable: true,
        wrap: true,
        searchable:true
      },
      {
          name: 'Network',
          key:'network',
          selector: (row:any) => row.network,
          sortable: true,
          wrap: true,
          searchable:true
      },
      {
        name:'Campaign',
        key:'campaignName',
        selector: (row:any) => row.campaignName,
        sortable: true,
        wrap: true,
        searchable:true
      },
      {
        name:'Transactions',
        key:'totalTransactions',
        format: (row:any) => formatNumberLocale(row.totalTransactions,0),
        selector: (row:any) => row.totalTransactions,
        sortable: true,
        wrap: true
      },
      {
        name:'Commission',
        key:'totalCommission',
        format: (row:any) => formatNumberLocale(row.totalCommission),
        selector: (row:any) => row.totalCommission,
        sortable: true,
        wrap: true,
        id:'totalCommission'
      }
  ]
  return columns
}
